import React, { FC } from 'react'
import VendorsListContainer from 'containers/Vendors/VendorsList'

const VendorListPage: FC = () => <VendorsListContainer />

export default VendorListPage
